import { Control, RegisterOptions } from 'react-hook-form';

export type DropdownFieldProps = {
  error: boolean;
  fullWidth?: boolean;
};

export type ContainerProps = {
  fullWidth?: boolean;
};

export type ModalDropdownInputProps = {
  label?: string;
  dropdownItems: Array<string>;
  selectedItem?: string;
  onSelect: (itemIndex: number) => void;
  onEndReached?: () => void;
  isLastPage?: boolean;
  fullWidth?: boolean;
  // ValidationProps
  name: string;
  control: Control<any, any>;
  rules?: RegisterOptions;
};

export { default as ModalDropdownInput } from './ModalDropdownInput';
